<app-header></app-header>

<div class="main">
  <div class="main-header">
    <div class="grey-div"></div>
    <div class="image-div">
      <img src="/assets/spruce-pro/even-header.gif" alt="header-image" class="img-fluid">
    </div>
    <div class="grey-div"></div>
  </div>

  <div class="customer-section py-5">
    <div class="container">
      <div class="our-customers-section">
        <div class="text-left mb-4">
          <div class="benefit-heading">
            <h1>Benefit from our experience</h1>
            <p class="lead">
              We offer 3rd party owned portfolios the same purpose-built servicing platform we built for ourselves, offering comprehensive end-to-end solar servicing, financial reporting, and SREC monetization.
            </p>
          </div>
        </div>
        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-3 mt-5 pt-0 pb-5 pt-lg-5 mt-lg-5">
          <div class="col d-flex justify-content-center">
            <div class="main-detail text-center">
              <div class="percent">
                <p>
                  <span class="percent-value">~145,000</span>
                </p>
              </div>
              <h3 class="title">solar assets managed</h3>
            </div>
          </div>
          <div class="col d-flex justify-content-center">
            <div class="main-detail text-center">
              <div class="percent">
                <p>
                  <span class="percent-value">~$1 billion</span>
                </p>
              </div>
              <h3 class="title">solar assets serviced</h3>
            </div>
          </div>
          <div class="col d-flex justify-content-center">
            <div class="main-detail text-center">
              <div class="percent">
                <p>
                  <span class="percent-value">15 years</span>
                </p>
              </div>
              <h3 class="title">track record in clean energy</h3>
            </div>
          </div>
          <div class="col d-flex justify-content-center">
            <div class="main-detail text-center">
              <div class="percent">
                <p>
                  <span class="percent-value">32+ states</span>
                </p>
              </div>
              <h3 class="title">w/active customers</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="banner py-5">
    <div class="overlay"></div>
    <div class="container content text-center">
      <p class="quote lead">
        Spruce PRO empowers solar portfolio owners with
        enhanced efficiency, flexibility, and productivity, fostering
        sustained value creation.
      </p>
    </div>
  </div>

  <div class="third-section py-5">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-12 col-lg-6 p-4 text-center">
          <div class="left-image">
            <img src="/assets/spruce-pro/PROMarketOptionsChart.jpg" alt="chart" class="img-fluid rounded" style="max-width: 90%; height: auto;">
          </div>
        </div>
        <div class="col-12 col-lg-6 p-4" id="pro-content">
          <div class="spruce-pro-right-text">
            <p class="lead">
              Spruce owns and the operates tens of the thousands of
              assets and can service your portfolio's financial, customer,
              and operating assets seamlessly.
            </p>
            <p class="lead">
               We leverage our expertise in solar utilities and finance to
              handle all essential business functions.
            </p>
            <p class="lead">
              We offer primary servicing that can be customized to specific needs,
              or can provide stability and security as a backup service provider.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="services-managed-section py-5 bg-light">
    <div class="container">
      <div class="services-heading text-center mb-4">
        <h1>
          We are a premier, full-scope, managed services provider that can provide value to a wide range of entities:
        </h1>
      </div>
      <div class="row row-cols-2 row-cols-md-3 row-cols-lg-5 justify-content-around mt-5 mb-5">
        <div class="col text-center mb-3">
          <div class="services">
            <img src="/assets/noun-bank.png" alt="bank" class="img-fluid" style="max-width: 100px; height: auto;">
            <p class="mt-3">Global Financial Institutions</p>
          </div>
        </div>
        <div class="col text-center mb-3">
          <div class="services">
            <img src="/assets/noun-investment-1.png" alt="investment-1" class="img-fluid" style="max-width: 100px; height: auto;">
            <p class="mt-3">Investment Firms</p>
          </div>
        </div>
        <div class="col text-center mb-3">
          <div class="services">
            <img src="/assets/noun-investment.png" alt="investment" class="img-fluid" style="max-width: 100px; height: auto;">
            <p class="mt-3">Cleantech Venture Funds</p>
          </div>
        </div>
        <div class="col text-center mb-3">
          <div class="services">
            <img src="/assets/noun-solar-panel.png" alt="solar-panel" class="img-fluid" style="max-width: 100px; height: auto;">
            <p class="mt-3">Asset Owners & Operators</p>
          </div>
        </div>
        <div class="col text-center mb-3">
          <div class="services">
            <img src="/assets/noun-utilities.png" alt="utilities" class="img-fluid" style="max-width: 100px; height: auto;">
            <p class="mt-3">Utilities & Retail Energy Providers</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="spruce-pro-servces-section py-5">
    <div class="container">
      <div class="benefit-heading text-center mb-4">
        <h1>Our Services</h1>
      </div>
      <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 mt-5">
        <div class="col">
          <div class="pro-card-services row h-100">
            <div class="inside-card-services p-0">
              <div class="col-12 p-0">
                <h4 class="card_header">
                  <span>Financial Asset Management</span>
                </h4>
              </div>
              <div class="col-12 p-3">
                <div class="card_description">
                  <p class="mt-0 mb-0">
                    In-depth financial services that span financial and
					operating reports, analysis, waterfalls & cash
					distributions, lender and tax equity partner management,
					tax services, and more.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="pro-card-services row h-100">
            <div class="inside-card-services p-0">
              <div class="col-12 p-0">
                <h4 class="card_header">
                  <span>Billing/Collections</span>
                </h4>
              </div>
              <div class="col-12 p-3">
                <div class="card_description">
                  <p class="mt-0 mb-0">
                    Easy payment options and billing portal for portfolio
                  customers along with streamlined payment processing,
                  account monitoring, and end-to-end collections activities
                  to ensure healthy and current accounts.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="pro-card-services row h-100">
            <div class="inside-card-services p-0">
              <div class="col-12 p-0">
                <h4 class="card_header">
                  <span>Asset Operations</span>
                </h4>
              </div>
              <div class="col-12 p-3">
                <div class="card_description">
                  <p class="mt-0 mb-0">
                    System monitoring and performance management tools combined with a broad network of partners, ensuring timely on-site maintenance or repair to sustain high-performing assets.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
         <div class="col">
          <div class="pro-card-services row h-100">
            <div class="inside-card-services p-0">
              <div class="col-12 p-0">
                <h4 class="card_header">
                  <span>SREC Marketplace</span>
                </h4>
              </div>
              <div class="col-12 p-3">
                <div class="card_description">
                  <p class="mt-0 mb-0">
                    Spruce's Environmental Commodities Markets (ECM) can assist
                  in meeting your company’s goals in sourcing credits,
                  maximizing SREC revenue or limiting future exposure to
                  volatility in environmental commodities.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="pro-card-services row h-100">
            <div class="inside-card-services p-0">
              <div class="col-12 p-0">
                <h4 class="card_header">
                  <span>Contact Center</span>
                </h4>
              </div>
              <div class="col-12 p-3">
                <div class="card_description">
                  <p class="mt-0 mb-0">
                     Dedicated US based support team and 24×7 online portal to answer homeowner/tenant questions regarding their agreements, system performance, and more.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="pro-card-services row h-100">
            <div class="inside-card-services p-0">
              <div class="col-12 p-0">
                <h4 class="card_header">
                  <span>Account Services</span>
                </h4>
              </div>
              <div class="col-12 p-3">
                <div class="card_description">
                  <p class="mt-0 mb-0">
                    Management of the entire customer account from start to finish, from UCC/fixture filing removals and system buyouts to performance guarantees and other end to end account services.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="pro-card-services row h-100">
            <div class="inside-card-services p-0">
              <div class="col-12 p-0">
                <h4 class="card_header">
                  <span>Servicing IT</span>
                </h4>
              </div>
              <div class="col-12 p-3">
                <div class="card_description">
                  <p class="mt-0 mb-0">
                    From a full-service customer facing portal to intuitive
					reporting, Spruce PRO offers full-stack technology
					implementation.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="py-5">
    <div class="container">
      <hr />
    </div>
    <div class="spruce-pro-servces-section py-5">
      <div class="container">
        <div class="benefit-heading text-center mb-4">
          <h1>Discover More</h1>
        </div>
        <div class="cards-container">
          <div class="card" (click)="downloadFile('SolarServicingDoc.pdf')">
            <div class="card-text">
              <h6 class="card-title">Solar Servicing</h6>
            </div>
            <div class="card-image">
              <img src="/assets/spruce-pro/thmbSolarServicing_110.png" alt="Image for Card 1">
            </div>
          </div>
          <div class="card" (click)="downloadFile('FinancialAssetManagement.pdf')">
            <div class="card-text">
              <h6 class="card-title">Financial Asset Management</h6>
            </div>
            <div class="card-image">
              <img src="/assets/spruce-pro/thmbFinAsstMngmt-110.png" alt="Image for Card 2">
            </div>
          </div>
          <div class="card" (click)="downloadFile('EnvironmentalCommodities.pdf')">
            <div class="card-text">
              <h6 class="card-title">Environmental Commodities</h6>
            </div>
            <div class="card-image">
              <img src="/assets/spruce-pro/thmbEnvronCommd-110.png" alt="Image for Card 3">
            </div>
          </div>
          <div class="card" (click)="downloadFile('CaseStudy_ResidentialSolarAssets.pdf')">
            <div class="card-text">
              <div>
                <h6 class="card-title">Case Study: <br>Residential Solar Assets</h6>
              </div>
            </div>
            <div class="card-image">
              <img src="/assets/spruce-pro/thmbCaseResiSolarAsset-110.png" alt="Image for Card 5">
            </div>
          </div>
          <div class="card" (click)="downloadFile('BackupServicing.pdf')">
            <div class="card-text">
              <div>
                <h6 class="card-title">Backup Servicing</h6>
              </div>
            </div>
            <div class="card-image" id="backup">
              <img src="/assets/spruce-pro/backupService.png" alt="Image for Card 5">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="leaderShip-section">
      <div class="container">
        <div class="leaderShip-text">
          <h2 class="name-leaderShip">Leadership Team</h2>
        </div>
        <div class="list-leaderShip">
          <div class="inner-leaderShip row mt-0 mt-lg-5 ms-0 pe-0">
            <div class="col-12 col-lg-3 ps-0">
              <div class="et_pb_blurb_content text-center">
                <div class="leadership2-image">
                  <img src="/assets/derick-profile.jpg" alt="derick-image"/>
                </div>
                <div class="et_pb_blurb_container">
                  <h4 class="mt-3 leader-name">Derick Smith</h4>
                  <div class="et_pb_blurb_description">
                    <p>Chief Operating Officer, Spruce Servicing</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-3 ps-0">
              <div class="et_pb_blurb_content text-center">
                <div class="leadership2-image">
                  <img src="/assets/Chris_Hayes_Square-copy.jpg" alt="chris-hayes-image"/>
                </div>
                <div class="et_pb_blurb_container">
                  <h4 class="mt-3 leader-name">Chris Hayes</h4>
                  <div class="et_pb_blurb_description">
                    <p>Chief Executive Officer</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="inner-leaderShip row mt-5 ms-0 pe-0">
            <div class="col-12 col-lg-3 ps-0">
              <div class="et_pb_blurb_content text-center">
                <div class="leadership2-image">
                  <img src="/assets/Arnold-Ybanez-Call-Center-Operations.png" alt="arnold-image"/>
                </div>
                <div class="et_pb_blurb_container">
                  <h4 class="mt-3 leader-name">Arnold Ybanez</h4>
                  <div class="et_pb_blurb_description">
                    <p>VP, Customer Experience</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-3 ps-0">
              <div class="et_pb_blurb_content text-center">
                <div class="leadership2-image">
                  <img src="/assets/Chris-Hayden.png" alt="chris-image"/>
                </div>
                <div class="et_pb_blurb_container">
                  <h4 class="mt-3 leader-name">Chris Hayden</h4>
                  <div class="et_pb_blurb_description">
                    <p>SVP, IT and Enterprise Applications</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-3 ps-0">
              <div class="et_pb_blurb_content text-center">
                <div class="leadership2-image">
                  <img src="/assets/Dan-Dadufalza-Asset-Recovery.png" alt="dan-image"/>
                </div>
                <div class="et_pb_blurb_container">
                  <h4 class="mt-3 leader-name">Dan Dadufalza</h4>
                    <div class="et_pb_blurb_description">
                      <p>Senior Director, Operations, Performance & Strategy</p>
                    </div>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="call-scheduling">
      <a href="mailto:pro@sprucepower.com">Send Us an Email</a>
    </div>
  </div>


<div class="contact-us-footer">
  <div class="green-div-one"></div>
    <div class="footer-container">
      <div class="inner-content-footer">
        <h2>Contact Us</h2>
        <p><a href="mailto:pro@sprucepower.com">pro&#64;sprucepower.com</a></p>
        <p>844-SPWR-PRO (844-779-7776)</p>
      </div>
    </div>
  <div class="green-div-two"></div>
</div>

<app-footer></app-footer>
